import React, { useState } from 'react'
import '../../index.css'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import { styled } from '@mui/material/styles'

const PREFIX = 'Obstacle-dialog'
const classes = {
  main: `${PREFIX}`,
}

const DialogStyled = styled(Dialog)({
  [`&.${classes.main} .MuiPaper-root`]: {
    maxWidth: '600px;',
    minWidth: '400px;',
  },
  [`&.${classes.main} .MuiDialogContent-root`]: {
    padding: '8px 24px',
  },
  [`&.${classes.main} .MuiTypography-h6`]: {
    textAlign: 'center',
  },
  [`&.${classes.main} .MuiOutlinedInput-input`]: {
    padding: '10.5px 14px',
  },
  [`&.${classes.main} .MuiFormLabel-root`]: {
    color: 'color: gray !important;',
    fontSize: 14,
  },
})

export default function ObstacleDialog(props) {
  const [name, setName] = useState('')

  const handleClose = () => {
    props.onChange(false)
    setName('')
  }

  const handleOk = () => {
    props.onChange(false, name)
    setName('')
  }

  const handleChange = e => {
    setName(e.target.value)
  }

  return (
    <DialogStyled
      open={props.open}
      onClose={handleClose}
      aria-labelledby="form-dialog-obstacle"
      className={classes.main}
    >
      <DialogTitle id="form-dialog-title">Add Obstacle</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          className="text-field-font"
          margin="dense"
          //id="name"
          id="outlined-secondary"
          label="Name"
          variant="outlined"
          value={name}
          fullWidth
          onChange={handleChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleOk} color="primary">
          Add
        </Button>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </DialogStyled>
  )
}
